// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import tool from './utils/tool.js'
Vue.prototype.$tool = tool

// 注册Element UI插件
Vue.use(ElementUI)

Vue.config.productionTip = false

// 添加全局导航守卫，检查登录状态和设置页面标题
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 会找我 - 专业会展设备租赁服务`
  } else {
    // 默认标题
    document.title = '会找我-专业会展设备租赁服务'
  }

  // 检查是否需要登录才能访问的路由
  const requiresAuth = to.matched.some(record => record.meta.requireAuth)

  try {
    // 尝试检查登录状态
    await store.dispatch('user/checkLoginStatus')

    if (requiresAuth && !store.getters['user/getIsLoggedIn']) {
      // 未登录，重定向到登录页
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      // 已登录或不需要登录的路由，继续访问
      next()
    }
  } catch (error) {
    console.error('检查登录状态失败:', error)
    if (requiresAuth) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js